import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hidden" }

import { watch } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'SlotVarWatcher',
  props: {
	modelValue: { default: null, type: [Object, Boolean, String, Number] }
},
  emits: ['changed'],
  setup(__props, { emit: emits }) {

const props = __props;





watch(
	() => props.modelValue, 
	(val) => emits('changed', val), 
	{ deep: true, immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})